import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { PeopleSearchProvider } from "@/contexts/PeopleSearchContext";
import { useIsMobile } from "@/hooks/use-mobile";
import {
	ResizableHandle,
	ResizablePanel,
	ResizablePanelGroup,
} from "@/components/ui/resizable";
import { FilterRail } from "./FilterRail";
import { CategoryPanel } from "./CategoryPanel";
import { SummaryBar } from "./SummaryBar";
import { ResultsPane } from "./ResultsPane";
import { MobileFiltersSheet } from "./MobileFiltersSheet";

export function PeopleSearchPage() {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	const header = (
		<PageHeader
			title={t("peopleSearch.title", "People Search")}
			description={t("peopleSearch.description", "Build a precise search across your whole candidate database")}
			className="mb-4"
		/>
	);

	if (isMobile)
		return (
			<PeopleSearchProvider>
				<div className="flex flex-col">
					<div className="flex items-start justify-between gap-2">
						{header}
						<MobileFiltersSheet />
					</div>
					<ResultsPane />
					<div className="sticky bottom-0 mt-3 -mx-4 px-0">
						<SummaryBar />
					</div>
				</div>
			</PeopleSearchProvider>
		);

	return (
		<PeopleSearchProvider>
			<div className="flex flex-col h-[calc(100vh-6rem)] min-h-[480px]">
				<div className="shrink-0">{header}</div>
				<ResizablePanelGroup
					direction="horizontal"
					autoSaveId="people-search-panes"
					className="flex-1 min-h-0 border rounded-sm bg-background"
				>
					<ResizablePanel defaultSize={18} minSize={14} maxSize={26}>
						<div className="h-full min-w-0 p-3">
							<FilterRail />
						</div>
					</ResizablePanel>
					<ResizableHandle withHandle />
					<ResizablePanel defaultSize={30} minSize={22} maxSize={42}>
						<div className="h-full min-w-0 p-4">
							<CategoryPanel />
						</div>
					</ResizablePanel>
					<ResizableHandle withHandle />
					<ResizablePanel defaultSize={52} minSize={35}>
						<div className="h-full min-w-0 p-4">
							<ResultsPane />
						</div>
					</ResizablePanel>
				</ResizablePanelGroup>
				<div className="shrink-0">
					<SummaryBar />
				</div>
			</div>
		</PeopleSearchProvider>
	);
}
